import { useMediaQuery, useTheme } from "@mui/material";

export const useMobile = (breakpoint = "sm") => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(breakpoint));
};
